/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { CreateFeeConfigOptions, CreateFeeConfigResponses } from '../types/CreateFeeConfig'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. Fails with 409 if the tier is already configured; use PUT to change an existing rate.
 * @summary Create the trading fee configuration of a tenant for a tier.
 * {@link /v1/fees/config}
 */
export function createFeeConfig<ThrowOnError extends boolean = true>(
  options: Options<CreateFeeConfigOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateFeeConfigResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/fees/config',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateFeeConfigResponses, ThrowOnError>>,
  )
}
